"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../hyperapp");
const actions_1 = require("./actions");
const state_1 = require("./state");
const view_1 = require("./components/view");
const ui_state_persistence_1 = require("../common/mixins/ui-state-persistence");
function renderHeaderApp({ container, tabs, onTabChange, editableId }) {
    return hyperapp_1.app({
        state: state_1.getDefaultState(),
        actions: actions_1.actions({ onTabChange }),
        view: (state, actions) => view_1.View({ state, actions, tabs }),
        mixins: [editableId ? ui_state_persistence_1.uiStatePersistence('header-app', editableId) : undefined],
        root: container,
    });
}
exports.renderHeaderApp = renderHeaderApp;
//# sourceMappingURL=header-app.js.map